import React from 'react'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import Sheet from 'components/utils/Sheet'
import FlashHotelRateOption from 'components/OfferPage/FlashHotel/SameRoom/FlashHotelRateOption'

interface Props {
  packageViews: Array<App.OfferPackageOptionView>
}

function FlashHotelPackageOptionsModalTab(props: Props) {
  const { packageViews } = props
  const intl = useIntl()

  const availablePackagesText = intl.formatMessage(
    {
      id: '/0Fr6muncP',
      defaultMessage: '{count, plural, one {# package option} other {# package options}} available',
      description: 'Text showing number of package options available',
    },
    {
      count: packageViews.length,
    },
  )

  return (
    <Pane background="neutral-six">
      {packageViews.length > 1 && (
        <Pane background="neutral-eight" padding="12 20">
          <BodyText variant="small" colour="neutral-three">
            {availablePackagesText}
          </BodyText>
        </Pane>
      )}
      <Group direction="vertical" gap={8}>
        {packageViews.map((view, index) => (
          <Sheet key={view.package.uniqueKey} border="neutral-six">
            <FlashHotelRateOption
              packageView={view}
              packagePosition={packageViews.length > 1 ? index + 1 : undefined}
            />
          </Sheet>
        ))}
      </Group>
    </Pane>
  )
}

export default FlashHotelPackageOptionsModalTab
